// src/components/common/GlobalUploadToast.jsx
import React from "react";
import UploadToast from "./UploadToast";

/**
 * GlobalUploadToast
 * -----------------
 * Renders the shared upload toast UI from a toast view model.
 *
 * @param {object} props
 * @param {null | { isOpen: true, percent: number, status: string, count: number }} props.toastModel
 * @returns {JSX.Element | null}
 */
export default function GlobalUploadToast({ toastModel }) {
  if (!toastModel) return null;

  return (
    <UploadToast
      isOpen={toastModel.isOpen}
      percent={toastModel.percent}
      status={toastModel.status}
      count={toastModel.count}
    />
  );
}